import { ScaleTime, scaleTime } from 'd3-scale';

import type { Timeseries } from '../../../types/timeseries.js';
import { TIMESTAMP_BAR_X_DEVIATION } from '../constants.js';

/**
 * Get x-scale for bar variant of the sparkline chart
 *
 * @param data - The timeseries data
 * @param width - The width of the plot area
 * @param padding - The padding of the chart
 * @param isBarVariant - Whether the sparkline is a bar variant
 * @returns The x-scale
 */
export const getSparklineXScale = (
  data: Timeseries,
  width: number,
  padding: number,
  isBarVariant?: boolean,
): ScaleTime<number, number> => {
  const rangeMax =
    width - padding - (isBarVariant ? TIMESTAMP_BAR_X_DEVIATION : 0);

  const xAxisDomain = {
    min: Infinity,
    max: -Infinity,
  };

  data.datapoints.forEach((datapoint) => {
    const start = datapoint.start.getTime();
    const end = datapoint.end?.getTime() ?? start;

    const timestamp = isBarVariant ? start : end;

    xAxisDomain.min = timestamp < xAxisDomain.min ? timestamp : xAxisDomain.min;
    xAxisDomain.max = end > xAxisDomain.max ? end : xAxisDomain.max;
  });

  return scaleTime()
    .domain([xAxisDomain.min, xAxisDomain.max])
    .range([padding, rangeMax]);
};
